import { makeCommsPage } from './commsPage'
import { CommsCategoriesView } from '../components/views/commsCategoriesView'

export default makeCommsPage({
    title: 'Categories & rules',
    intro: 'The categories the model sorts inbound email into, the data points it extracts, and the rules that classify without a model call.',
    probeUrl: 'comms/categories/list',
    View: CommsCategoriesView,
    className: 'commsCategories',
})
